import ProductFilterService from "../../classes/ProductFilterService";

const productFilterService = new ProductFilterService();

export const state = () => ({
  filterData: null,
  coloredProducts: [],
  filters: [],
  queryFilters: null,
  categoryTree: null,
  order: null,
  orderOptions: null,
  hideCounter: null,
  aggregationsData: null,
  aggregationsDataForActiveFilters: null,
});

export const getters = {
  filterData: (state) => state.filterData,
  coloredProducts: (state) => state.coloredProducts,
  filters: (state) => state.filters,
  queryFilters: (state) => state.queryFilters,
  order: (state) => state.order,
  orderString: (state) => (state.order ? `sort=${state.order.value}&` : ""),
  orderOptions: (state) => state.orderOptions,
  hideCounter: (state) => state.hideCounter,
  aggregationsData: (state) => state.aggregationsData,
  aggregationsDataForActiveFilters: (state) =>
    state.aggregationsDataForActiveFilters,
};

export const mutations = {
  SET_HIDE_COUNTER: (state, hideCounter) => {
    state.hideCounter = hideCounter;
  },
  SET_COLORED_PRODUCTS: (state, coloredProducts) => {
    state.coloredProducts = productFilterService.extendColoredProductCategories(
      state.categoryTree,
      coloredProducts
    );
  },
  SET_FILTER_DATA: (state, filterData) => {
    state.filterData = productFilterService.extendFilterData(
      filterData,
      state.coloredProducts
    );
  },
  SET_CATEGORY_TREE: (state, categoryTree) => {
    state.categoryTree = categoryTree;
  },
  SET_FILTERS: (state) => {
    const filters = {
      attributes: [],
      trademarks: [],
      sizes: [],
      colors: [],
      cuts: [],
      materials: [],
      stickers: [],
      seasons: [],
      categories: [],
      orderGroups: [],
      genders: [],
      cmsStickers: [],
    };

    // state.filters = productFilterService.getFiltersFromUrl(state.filterData, filters);
    state.filters = productFilterService.getFiltersFromUrlElastic(
      state.filterData,
      filters
    );
    // state.queryFilters = productFilterService.getQueryFilters(state.filters, state.filterData);
    state.queryFilters = productFilterService.getQueryFiltersElastic(
      state.filters,
      state.filterData
    );
  },
  SET_FILTER: (state, { key, value, filters }) => {
    if (filters) {
      state.filters = filters;
    } else {
      state.filters[key] = value;
    }

    // state.queryFilters = productFilterService.getQueryFilters(state.filters, state.filterData);
    state.queryFilters = productFilterService.getQueryFiltersElastic(
      state.filters,
      state.filterData
    );
  },
  SET_ORDER: (state, order) => {
    if (order) {
      state.order = order;
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const orderValue = urlParams.get("sort");

    state.order = state.orderOptions.find((order) => order.value == orderValue);
  },
  SET_ORDER_OPTIONS: (state, orderOptions) => {
    state.orderOptions = orderOptions;
  },
  SET_AGGREGATIONS_DATA: (state, filterData) => {
    state.aggregationsData = filterData;
  },
  SET_AGGREGATIONS_DATA_FOR_ACTIVE_FILTERS: (state, data) => {
    state.aggregationsDataForActiveFilters = data;
  },
};
